import { render, staticRenderFns } from "./UploadFilePreview.vue?vue&type=template&id=12d3a73d&scoped=true&"
import script from "./UploadFilePreview.vue?vue&type=script&lang=js&"
export * from "./UploadFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilePreview.vue?vue&type=style&index=0&id=12d3a73d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3a73d",
  null
  
)

export default component.exports